import { getInlineDownloadStyle as sharedStyle } from '@bingads-webui-campaign-react/common-styles';

export const getInlineDownloadStyle = sharedStyle;
